import { AxiosRequestConfig, AxiosResponse, Method } from 'axios'
import singleToken from '@xt/client/experimental/request/token'
import axiosInstance from './index'
import { ResponseError, Result } from './types.d'
import { requestStart } from './interceptors'
import { reportEntryLog } from '@xt/client/utils/log'

export async function $service<T = any, R = AxiosResponse<T>, D = any>(
  options: AxiosRequestConfig & { method?: Method }
): Promise<Result<T>> {
  const { url, baseURL, method = 'GET', data, params, headers, timeout, responseType = 'json', onUploadProgress, signal } = options

  requestStart()

  return axiosInstance
    .request<T, R, D>({
      url,
      baseURL,
      method,
      data,
      // 追加到URL地址栏上的参数
      params,
      headers,
      timeout,
      signal,
      responseType,
      onUploadProgress
    })
    .then(
      resp => {
        const response = resp as AxiosResponse<T>

        if (!response) {
          singleToken.reportLog()
          reportEntryLog('debug.request.no-response', { url, method, headers })
        }

        return Promise.resolve([null, response.data, response])
      },
      (error: ResponseError) => {
        return Promise.resolve([{ errCode: error.errCode, errMsg: error.errMsg, httpCode: error.httpCode }, null, null])
      }
    )
}
